export const defaultState = {
  blueprintsFromApi: [],
  blueprints: [],
  selectedBlueprint: null,

  search: null,
  type: null,
  function: null,
};

export function blueprintReducer(state, action) {
  switch (action.type) {
    case 'init': {
      const { payload } = action;
      return {
        ...state,
        blueprintsFromApi: payload?.blueprints,
        blueprints: payload?.blueprints,
        selectedBlueprint: payload?.blueprints[0],
      };
    }

    case 'set-selected-blueprint': {
      const { payload } = action;
      return {
        ...state,
        selectedBlueprint: payload?.blueprint,
      };
    }

    case 'clear-filter': {
      const { blueprintsFromApi } = state;
      return {
        ...state,
        blueprints: blueprintsFromApi,
        selectedBlueprint: blueprintsFromApi[0],
        type: null,
        function: null,
      };
    }

    case 'filter': {
      const { payload } = action;
      const { type, value, ats_enabled } = payload;
      const { blueprintsFromApi } = state;

      let result = {
        ...state,
        [type]: value,
      };

      if (result?.search) {
        const searchResult = blueprintsFromApi?.filter((currBp) =>
          currBp?.name?.toLocaleLowerCase()?.includes(value)
        );
        return {
          ...result,
          blueprints: searchResult,
          selectedBlueprint: searchResult[0],
        };
      }

      const fromKulaType = (currBp) => currBp?.from_kula;
      const fromOrgType = (currBp) => !currBp?.from_kula;
      const all = (currBp) => currBp;

      const filterDepartment = (currBp) =>
        currBp?.tag_names.includes(result?.function);
      const filterAtsDepartment = (currBp) =>
        currBp?.ats_department_id === result?.function;

      const typeFilter =
        result?.type && result?.type !== 'all'
          ? result?.type === 'kula'
            ? fromKulaType
            : fromOrgType
          : all;
      const departmentFilter =
        result?.function && result?.function !== 'all' ? filterDepartment : all;

      const atsDepartmentFilter =
        result?.function && result?.function !== 'all'
          ? filterAtsDepartment
          : all;

      const searchNonAtsResult = blueprintsFromApi
        .filter(typeFilter)
        .filter(departmentFilter);

      const searchAtsResult = blueprintsFromApi
        .filter(typeFilter)
        .filter(atsDepartmentFilter);

      const searchResult = ats_enabled ? searchAtsResult : searchNonAtsResult;

      return {
        ...result,
        blueprints: searchResult,
        selectedBlueprint: searchResult[0],
      };
    }

    default:
      return { ...state };
  }
}
